import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import UbiquitiFocus from './components/UbiquitiFocus';
import GuestWiFi from './components/GuestWiFi';
import Industries from './components/Industries';
import DeepDive from './components/DeepDive';
import CTA from './components/CTA';
import Footer from './components/Footer';
import '@questlabs/react-sdk/dist/style.css';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-200 selection:text-blue-900">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <UbiquitiFocus />
        <GuestWiFi />
        <Industries />
        <DeepDive />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;